import * as yup from 'yup';

export const generateSchema = audience =>
  yup.object().shape({
    name: yup
      .string()
      .required('Name cannot be empty')
      .notOneOf([audience.name], 'Name of duplicated audience has to be different than current'),
  });
